// Top-level Sentry ErrorBoundary fallback (Cluster 2 Risk-Reducer F.5,
// 2026-05-07). Catches unhandled React JS-errors. Wired in `pwa/src/main.tsx`
// as the `fallback` prop on `<Sentry.ErrorBoundary>`. Briefing Kap. 11
// line 1562-1579 prescribes the verbatim copy + Flitzi illustration +
// secondary CTA + support@ footer.
//
// Recovery uses `window.location` (not `useNavigate`) — the fallback may
// render outside the React Router context if the boundary catches at the
// top of the tree.
import { StoryErrorBlock } from '@/components/patterns/StoryErrorBlock';
import { FLITZI_IMAGE_SRC } from '@/features/story/error-variants';
import { STRINGS } from '@/strings/strings';

export function TechnicalErrorFallback() {
  const S = STRINGS.errorBoundary;
  return (
    <div className="flex min-h-screen items-center justify-center bg-dream-light-blue px-4">
      <StoryErrorBlock
        illustrationSrc={FLITZI_IMAGE_SRC}
        illustrationAlt={S.illustrationAlt}
        title={S.title}
        body={S.subText}
        primaryCta={{
          label: S.ctaPrimary,
          onClick: () => window.location.reload(),
        }}
        secondaryCta={{
          label: S.ctaSecondary,
          onClick: () => {
            window.location.href = '/';
          },
        }}
        footer={
          <p>
            {S.footerPrefix}
            <strong>
              <a href={`mailto:${S.footerEmail}`} className="underline">
                {S.footerEmail}
              </a>
            </strong>
          </p>
        }
        testId="technical-error-fallback"
      />
    </div>
  );
}
